var _filter, _filter2, _filter3, _filter4, _filter5, _linearGradient, _linearGradient2, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHerogradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 908,
    viewBox: "0 0 1106 908",
    width: 1106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 587.842,
    width: 988.359,
    x: 39.0068,
    y: 318.08
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 71.1864
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 675.4,
    width: 864.804,
    x: 29.3312,
    y: 157.811
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 71.1864
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 640.754,
    width: 738.853,
    x: 353.059,
    y: 222.698
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 71.1864
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 564.867,
    width: 949.445,
    x: 0.724327,
    y: 176.331
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 60.7519
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 561.053,
    width: 876.005,
    x: 229.489,
    y: 262.914
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 60.7519
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 140.261,
    x2: 338.315,
    y1: 609.361,
    y2: 198.185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bda1f8",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 482,
    x2: 943.567,
    y1: 428,
    y2: 498.544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee797a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d45c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#60429f",
    rx: 365.492,
    ry: 114.581,
    transform: "matrix(.956791 .290775 -.333088 .942896 533.186 612.001)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.336 357.721c-99.8689-129.458 275.664-.001 443.664-.001s133.48 195.618 52.66 239.069c-80.821 43.451-285.604 137.228-422.66 71.211s26.206-180.822-73.664-310.279z",
    fill: "url(#f)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#f8d45c",
    rx: 178.257,
    ry: 226.85,
    transform: "matrix(.0582919 -.9983 .999831 -.0183949 722.486 543.075)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.265 338.813c154.06-16.999 322.154-91.262 400.224 15.475 78.071 106.737 19.895 214.891-80.489 245.849s-495.929 36.6-574-70.137c-78.0708-106.737 153.881-160.228 254.265-191.187z",
    fill: "#c2a0fd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m369.697 421.297c59.093-59.911 234.104-42.992 398.773 23.093 164.67 66.084 256.64 156.308 197.547 216.219s-240.488 54.907-405.158-11.177c-164.669-66.085-250.255-168.224-191.162-228.135z",
    fill: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerogradient);
export default __webpack_public_path__ + "static/media/herogradient.7937fb8639299f60e7d8cec142aba51c.svg";
export { ForwardRef as ReactComponent };